import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import ctaData from '../data/cta.json';
import businessData from '../data/businessdata.json';
import SafeIcon from '../common/SafeIcon';

const CTA = () => {
  const { t } = useLanguage();

  return (
    <section className="relative py-20 bg-gray-900 overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img 
          src={ctaData.bgImage} 
          alt="CTA Background" 
          className="w-full h-full object-cover opacity-10 scale-105"
        />
      </div>
      
      <div className="container mx-auto px-4 relative z-10">
        <div className="bg-brand rounded-[2.5rem] p-8 md:p-14 text-center shadow-xl shadow-brand/20 overflow-hidden relative border border-white/10">
          {/* Subtle background icon */}
          <div className="absolute -top-10 -right-10 p-10 opacity-5 pointer-events-none">
            <SafeIcon name="Droplet" className="text-[12rem]" />
          </div>
          
          <h2 className="text-3xl md:text-5xl font-black text-white mb-4 max-w-3xl mx-auto leading-tight">
            {t('cta.title')}
          </h2>
          
          <p className="text-lg text-white/90 mb-2 max-w-xl mx-auto font-medium">
            {t('cta.subtitle')}
          </p>
          
          <div className="flex items-center justify-center gap-3 mb-10">
            <span className="w-6 h-[1px] bg-white/30"></span>
            <span className="text-white/80 font-bold uppercase tracking-[0.15em] text-[10px] md:text-xs">
              {t('cta.supportingLine')}
            </span>
            <span className="w-6 h-[1px] bg-white/30"></span>
          </div>
          
          <div className="flex flex-col sm:flex-row justify-center items-center gap-4">
            <a 
              href={`tel:${businessData.phoneRaw}`}
              className="w-full sm:w-auto flex justify-center items-center gap-2.5 bg-white text-brand hover:bg-gray-50 px-8 py-4 rounded-full font-black text-lg transition-all shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 active:scale-95"
            >
              <SafeIcon name="Phone" className="text-xl" />
              {t('cta.callBtn')}
            </a>
            
            <a 
              href={`mailto:${businessData.email}`}
              className="w-full sm:w-auto flex justify-center items-center gap-2.5 bg-transparent border-2 border-white/30 hover:bg-white/10 text-white px-8 py-4 rounded-full font-black text-lg transition-all active:scale-95"
            >
              <SafeIcon name="Mail" className="text-xl" />
              {t('cta.emailBtn')}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTA;